module.exports = __webpack_public_path__ + "img/enel_foundation_logo.42fe61ea.png";